import AccountGroupsSaga from "./saga";
import AccountGroupsTable from "./reducers/AccountGroupsTableReducer";
import AsyncComponent from "ui/AsyncComponent";
import { registerRoutings } from "rootRouting";
import store from "rootStore";
import { url as Url } from "app/Settings/config";
import { permissionsType, routingType } from "types/configTypes";

interface IConfig {
    permissions: {
        create: boolean;
        delete: boolean;
        read: boolean;
        update: boolean;
    };
    routing: Array<string>;
    url: string;
}

export const permissionKey = "account_group";

export const url = `${Url}/accountGroups`;

const getConfig = (permissions: permissionsType) => {
    const modulePermissions = permissions.filter(
        (item) => item.indexOf(permissionKey) === 0,
    );

    const config: IConfig = {
        permissions: {
            create: modulePermissions.indexOf(permissionKey + ".create") !== -1,
            delete: modulePermissions.indexOf(permissionKey + ".delete") !== -1,
            read: modulePermissions.indexOf(permissionKey + ".read") !== -1,
            update: modulePermissions.indexOf(permissionKey + ".update") !== -1,
        },
        routing: [],
        url,
    };

    let routing: routingType = [];

    // create, update, read, delete
    if (config.permissions.update) {
        store.reducerManager?.add("AccountGroupsTable", AccountGroupsTable);
        store.injectSaga?.("AccountGroupsSaga", AccountGroupsSaga);

        routing.push({
            path: url,
            element: (
                <AsyncComponent path="AccountGroups/pages/AccountGroupsIndexPage" />
            ),
        });
    }

    if (config.permissions.create) {
        routing.push({
            path: `${url}/create`,
            element: (
                <AsyncComponent path="AccountGroups/pages/AccountGroupsCreatePage" />
            ),
        });
    }

    if (routing.length > 0) {
        config.routing = routing.map((item) => item.path);
        registerRoutings(routing);
    }

    return config;
};

export default getConfig;
